module.exports = __webpack_public_path__ + "img/concrete-hole-decal-09.85e6a3b8.png";